import styled, { css } from 'styled-components';

// TODO: `components` should not import from `pages`.
import YatTextInput from '@app/pages/Prototype/Grid/GridItem/Link/TextInput';

import { Typography } from '../../../DesignSystem';

export const InputWrapper = styled.div`
    display: flex;
    width: 100%;
    position: relative;
    flex-direction: column;
`;

export const InputContainer = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 10px;
    width: 100%;
`;

interface StyledInputProps {
    $multiline: boolean;
}

export const StyledTypography = styled(Typography)`
    width: 100%;
`;

// TODO: Remove redundant code (if approved, use component for other items).
export const StyledInput = styled(YatTextInput)<StyledInputProps>`
    background: linear-gradient(109.49deg, rgba(255, 255, 255, 0.13) -4.86%, rgba(255, 255, 255, 0) 98.1%),
        linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #000000;
    border: 1px solid;
    border-image: linear-gradient(295.84deg, rgba(255, 255, 255, 0.15) 5.36%, rgba(255, 255, 255, 0) 41.35%);
    border-radius: 60px;

    ${({ $multiline }) =>
        $multiline
            ? css`
                  padding: 10px 55px 10px 15px;
                  border-radius: 10px;
              `
            : css`
                  padding: 0 15px;
              `}
`;
